export const USER_GROUPS = {
  BETA_PROGRAM: "betaprogram",
  FIXED_ROUTES: "fixedroutes"
};
